import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../types/AuthTypes";
import { apiClient } from "src/utils/Api/apiClient";
import axios from "axios";

interface authState {
        authUser: User | null;
        isAuthenticated: boolean;
        token: string | null;
        authLoading: boolean;
        authError: string | null;
}

const initialState: authState = {
        authUser: null,
        isAuthenticated: false,
        token: null,
        authLoading: false,
        authError: null
}



export const loginUser = createAsyncThunk(
        'auth/login',
        async (credentials: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('auth/login', credentials).then();
                        return response.data;
                } catch (authError: any) {
                        return rejectWithValue(authError.response.data || 'An error occured');
                }
        }
);

export const loginUserWithToken = createAsyncThunk(
        'auth/loginWithToken',
        async (credentials: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('auth/loginWithToken', credentials).then();
                        return response.data;
                } catch (authError: any) {
                        return rejectWithValue(authError.response.data || 'An error occured');
                }
        }
);

export const logoutUser = createAsyncThunk(
        'auth/logout',
        async (credentials: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('auth/logout', credentials);
                        return response.data;
                } catch (authError: any) {
                        return rejectWithValue(authError.reponse.data || 'An error occured');
                }
        }
);

const authSlice = createSlice({
        name: 'auth',
        initialState,
        reducers: {
                reset: () => initialState
        },
        extraReducers: (builder) => {
                //user login reducers
                builder.addCase(loginUser.pending, (state) => {
                        state.authLoading = true;
                        state.authError = null;
                });
                builder.addCase(loginUser.fulfilled, (state, action) => {
                        state.authLoading = false;
                        state.authUser = action.payload.user;
                        state.isAuthenticated = true;
                        state.token = action.payload.token;
                        localStorage.setItem('authToken', action.payload.token);
                });
                builder.addCase(loginUser.rejected, (state, action) => {
                        state.authLoading = false;
                        state.authError = action.payload as string;
                });

                //user loginwithtoken reducers
                builder.addCase(loginUserWithToken.pending, (state) => {
                        state.authLoading = true;
                        state.authError = null;
                });
                builder.addCase(loginUserWithToken.fulfilled, (state, action) => {
                        state.authLoading = false;
                        state.authUser = action.payload.user;
                        state.isAuthenticated = true;
                        state.token = action.payload.token;
                        localStorage.setItem('authToken', action.payload.token);
                });
                builder.addCase(loginUserWithToken.rejected, (state, action) => {
                        state.authLoading = false;
                        localStorage.removeItem('authToken');
                });

                //user logout reducers
                builder.addCase(logoutUser.pending, (state) => {
                        state.authLoading = true;
                        state.authError = null;
                });
                builder.addCase(logoutUser.fulfilled, (state, action) => {
                        state.authLoading = false;
                        state.authUser = null;
                        state.isAuthenticated = false;
                        state.token = null;
                        localStorage.removeItem('authToken');
                });
                builder.addCase(logoutUser.rejected, (state, action) => {
                        state.authLoading = false;
                        state.authError = action.payload as string;
                });
        }
});

export const { reset } = authSlice.actions;
export default authSlice.reducer;
